// src/components/ProductNotFound.jsx
import React from "react";

const ProductNotFound = () => (
  <div className="text-center text-red-600 font-bold">
    Product not found
  </div>
);

export default ProductNotFound;
